import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthorizationGuard } from './security/authorization.guard';
import { AdminComponent } from './theme/layout/admin/admin.component';
import { AuthComponent } from './theme/layout/auth/auth.component';
import { MedicalStaffComponent } from './theme/layout/medical-staff/medical-staff.component';

const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: '',
        redirectTo: 'hospital/hosp-dashboard',
        pathMatch: 'full',
      },
      {
        path: 'hospital',
        canActivate: [AuthorizationGuard],
        loadChildren: () =>
          import('./demo/pages/hospital/hospital.module').then(
            (module) => module.HospitalModule
          ),
      },
    ],
  },
  {
    path: 'medical-staff',
    component: MedicalStaffComponent,
    canActivate: [AuthorizationGuard],
    data: { roles: ['ROLE_MEDICAL_STAFF'] },
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./demo/pages/medical-staff/medical-staff.module').then(
            (module) => module.MedicalStaffModule
          ),
      },
    ],
  },
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./demo/pages/authentication/authentication.module').then(
            (module) => module.AuthenticationModule
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
